import {useState, useEffect, useRef, Fragment, memo, useContext} from "react"
import {SocketContext} from '@src/utility/context/Socket'
import {Link} from "react-router-dom"
import Avatar from "@components/avatar"
import {useDispatch, useSelector} from "react-redux"
import {
    storeMessagesInRedux,
    addBrandContactsInRedux,
    sendMsgRD,
    uploadMediaToserver,
    recieveMsg,
    sendBroadcastMsg,
    myRdList,
    allRdList,
    archiveConversation
} from "./store/actions"
import {
    getFavoriteFolders,
    getFavoriteRDProfiles
} from '@src/redux/actions/brandsDashboard'
import classnames from "classnames"
import PerfectScrollbar from "react-perfect-scrollbar"
import CustomAvatar from '@src/views/components/CustomAvatar'
import {
    MessageSquare,
    Paperclip,
    FileText,
    Heart,
    ArrowLeftCircle,
    File,
    ChevronLeft,
    Send,
    Image,
    X,
    MessageCircle,
    Info,
    Users
} from "react-feather"
import {
    Form,
    Label,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Button,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    FormGroup,
    CustomInput,
    Card,
    CardBody,
    Row,
    Col,
    Spinner,
    Alert
} from "reactstrap"
import {allowedFiles, allowedFilesErrorMessages} from '@src/utility/Utils'
import BlankProfile from "@src/assets/images/avatars/avatar-blank.png"
import {Slide, toast} from "react-toastify"
import {getGoalsAttributes} from '@src/views/brands/nutritionExperts/store/actions'
import {
    rdGroupList,
    rdGroupListReset
} from "@src/redux/actions/BrandActions"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import draftToHtml from "draftjs-to-html"
import {ContentState, convertToRaw, EditorState} from "draft-js"
import {Editor} from "react-draft-wysiwyg"
import '@styles/react/libs/editor/editor.scss'
import '@styles/base/plugins/forms/form-quill-editor.scss'
import htmlToDraft from "html-to-draftjs"
import {PropTypes} from "prop-types"
import MsgTemplates from '@src/views/components/MsgTemplates'
import useMessageFollowUp from '@src/views/components/hooks/useMessageFollowUp'

const ChatLog = (props) => {
    const sweetAlert = withReactContent(Swal)

    const ps = useRef([])
    const {
        handleUser,
        handleUserSidebarRight,
        handleSidebar,
        store,
        userSidebarLeft,
        user,
        selectedUserID,
        selectedUserBrandChat,
        selectedContactDetail,
        currentUser,
        onTabChange
    } = props

    const brandChatStoreSlice = useSelector((state) => state.chatBrands)

    const brandsDashboardStoreSlice = useSelector(store => store.brandsDashboardSlice)

    const {
        rdGroupListLoading,
        rdGroupListData,
        rdGroupListError
    } = useSelector(state => state.brandReducer)

    const chatArea = useRef(null)
    const dispatch = useDispatch()
    const socket = useContext(SocketContext)

    const chatMessages = selectedUserBrandChat?.data || []
    const currentUserId = currentUser?.chat_id || currentUser?.id
    const {showFollowUp, daysSince} = useMessageFollowUp(chatMessages, currentUserId)

    // ** State
    const [msg, setMsg] = useState("")
    const [questate, setQueState] = useState({inQueFilePreview: "", inQueFile: ""})
    const [selectedFile, setSelectedFile] = useState(null)
    const [isFilePicked, setIsFilePicked] = useState(false)
    const [isOpenTempleteModal, setIsOpenTempleteModal] = useState(false)
    const [isOpenBroadcastModal, setIsOpenBroadcastModal] = useState(false)
    const [broadcastMessage, setBroadcastMessage] = useState('')
    const [selectedBroadcastContacts, setSelectedBraodcastContacts] = useState([])
    const [broadCastRDsList, setBroadCastRDsList] = useState([])
    const [broadCastRDsListLoading, setBroadCastRDsListLoading] = useState(false)
    const [fileUploadError, setFileUploadError] = useState(false)
    const [checkAllVal, setCheckAllVal] = useState(false)
    const [showFav, setShowFav] = useState(false)
    const [favFolderList, setFavFolderList] = useState(null)
    const [favFolderId, setFavFolderId] = useState(null)
    const [favFolderTitle, setFavFolderTitle] = useState(null)
    const [backToFav, setBackToFav] = useState(false)
    const [showPreviewModal, setShowPreviewModal] = useState(false)
    const [selectedRds, setSelectedRds] = useState([])
    const [selectedRadio, setSelectedRadio] = useState('')
    const [broadCastSendLoader, setBroadCastSendLoader] = useState(false)
    const [broadCastResMsg, setBroadCastResMsg] = useState(null)
    const [broadCastResStatus, setBroadCastResStatus] = useState(null)
    const [sendMsgLoader, setSendMsgLoader] = useState(false)
    const [showGroups, setShowGroups] = useState(false)
    const [groupData, setGroupData] = useState({speciality: [], industry: [], characteristics: []})
    const [massMsgEditorState, setMassMsgEditorState] = useState(null)
    const [msgEditorState, setMsgEditorState] = useState(null)
    const [templateType, setTemplateType] = useState(null)
    const [openTemplatesModal, setOpenTemplatesModal] = useState(false)

    const scrollToBottom = () => {
        if (chatArea.current) {
            chatArea.current.scrollTop = chatArea.current.scrollHeight
        }
    }

    useEffect(() => {
        socket.on("connect", (error) => {
            if (error) {
                alert(error)
            }
        })

        const user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
        socket.emit("join", user, (error) => {
        })

        if (selectedUserID) {
            const selectedChatRdContactRaw = localStorage.getItem('selectedChatRd')
            const selectedChatRdContact = selectedChatRdContactRaw ? JSON.parse(selectedChatRdContactRaw) : {}
            dispatch(addBrandContactsInRedux({chat_user: parseInt(selectedUserID), ...selectedChatRdContact}))
        }

        dispatch(getGoalsAttributes())
    }, [])

    useEffect(() => {
        if (selectedContactDetail) {
            scrollToBottom()
        }

        if (!!brandChatStoreSlice?.braodcastContactList) {
            setBroadCastRDsListLoading(false)
            setBroadCastRDsList(brandChatStoreSlice.braodcastContactList.data)
        }

        if (!!brandChatStoreSlice?.broadcastResponse) {
            if (brandChatStoreSlice?.broadcastResponse?.status === true) {
                setBroadCastResMsg(brandChatStoreSlice?.broadcastResponse?.msg)
                setBroadCastResStatus(brandChatStoreSlice?.broadcastResponse?.status)
                setBroadCastSendLoader(false)
                setIsOpenBroadcastModal(false)
                setSelectedBraodcastContacts([])
                setCheckAllVal(false)
                setBroadCastRDsList([])
                dispatch({type: 'CLEAT_BROADCAST_LIST'})
                dispatch({type: 'CLEAT_BROADCAST_SUCCESS_RESPONSE'})
                dispatch({type: 'CLEAR_CHAT_CONTENT_ON_LOAD'})
                dispatch({type: 'CLEAR_CHAT_CONTACT_ON_LOAD'})
                setTimeout(() => {
                    setShowPreviewModal(false)
                    setBroadCastResMsg(null)
                    setBroadCastResStatus(null)
                    setSelectedRds([])
                    setBroadcastMessage("")
                    setMassMsgEditorState(null)
                }, 5000)
            }

            if (brandChatStoreSlice?.broadcastResponse?.config) {
                sweetAlert.fire({
                    title: 'Error!',
                    icon: 'error',
                    html: `<p>Status: ${brandChatStoreSlice?.broadcastResponse?.response?.status || 500}</p><p>${JSON.stringify(brandChatStoreSlice?.broadcastResponse?.response?.data ?? "Internal Server Error")}</p>`,
                    allowOutsideClick: false,
                    showCancelButton: false
                })
                setBroadCastSendLoader(false)
                dispatch({type: 'CLEAT_BROADCAST_SUCCESS_RESPONSE'})
            }
        }

        if (brandChatStoreSlice?.sendMessageResponse) {
            setSendMsgLoader(false)
            if (brandChatStoreSlice?.sendMessageResponse.status) {
                toast.success(
                    <Fragment>
                        <div className='toastify-header'>
                            <div className='title-wrapper'>
                                <Avatar size='sm' color='success' icon={<MessageSquare size={12}/>}/>
                                <h6 className='toast-title font-weight-bold'>Success</h6>
                            </div>
                        </div>
                        <div className='toastify-body'>
                            <span>{brandChatStoreSlice?.sendMessageResponse?.msg}</span>
                        </div>
                    </Fragment>, {transition: Slide, hideProgressBar: true, autoClose: 5000})
            } else {
                toast.error(<Fragment>{brandChatStoreSlice?.sendMessageResponse?.msg}</Fragment>, {
                    transition: Slide,
                    hideProgressBar: true,
                    autoClose: 5000
                })
            }
            setMsg("")
            setMsgEditorState(null)
            dispatch({type: "SEND_MSG_NULL_RESPONSE"})
        }

        const error = brandChatStoreSlice?.chatLoadError?.response?.status
        if (error && error !== 401) {
            dispatch({type: "BRAND_CHAT_LOAD_ERROR_RESET"})
            dispatch({type: "SELECTED_CHAT_LOADER_RESET"})
            sweetAlert.fire({
                title: 'Connection Error!',
                icon: 'error',
                html: '<p>Please reload the page.</p>',
                confirmButtonText: 'Reload',
                allowOutsideClick: false,
                showCancelButton: true
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload()
                }
            })
        }
    }, [brandChatStoreSlice])

    useEffect(() => {
        socket.on('new-user-message', (data) => {
            const receivedMessage = {
                message: data.data.message,
                media: data.data.media,
                from_user_id: data.data.from_user_id,
                to_user_id: data.data.to_user_id
            }
            // console.log('new-user-message data', data)
            // console.log('new-user-message', receivedMessage)
            dispatch(recieveMsg(receivedMessage))
        })
    }, [])

    useEffect(() => {
        if (brandsDashboardStoreSlice?.favoriteFoldersRes) {
            setBroadCastRDsListLoading(false)
            setFavFolderList(brandsDashboardStoreSlice?.favoriteFoldersRes?.data)
        }

        if (brandsDashboardStoreSlice?.favoriteRDProfilesRes) {
            setBroadCastRDsListLoading(false)
            const data = brandsDashboardStoreSlice?.favoriteRDProfilesRes?.data.map((item) => {
                return {
                    user_id: item.id,
                    profile_img: item.profile_img,
                    name: item.name,
                    is_favorite: null,
                    folder_title: null
                }
            })
            setBroadCastRDsList(data)
        }
    }, [brandsDashboardStoreSlice])

    useEffect(() => {
        if (rdGroupListData?.data) {
            setBroadCastRDsList(rdGroupListData?.data)
            setSelectedBraodcastContacts(rdGroupListData?.data.map(item => item?.user_id))
            setSelectedRds(rdGroupListData?.data.map(item => item?.name))
        }
    }, [rdGroupListData])

    const getBase64 = (img, callback) => {
        if (img) {
            const reader = new FileReader()
            reader.addEventListener('load', () => callback(reader.result))
            reader.readAsDataURL(img)
        }
    }

    const handleSendMsg = (e) => {
        e.preventDefault()
        setSendMsgLoader(true)
        const user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
        const receiver_id = selectedContactDetail.chat_user
        const date = new Date()
        const objTest = {
            chat: [],
            selectedRd: selectedUserID
        }
        const msgObj = {
            message: msg,
            from_user_id: user.chat_id,
            to_user_id: receiver_id,
            timezone: date.toString()
        }
        objTest.chat.push(msgObj)
        dispatch(storeMessagesInRedux(objTest))
        dispatch(sendMsgRD(msgObj))
        socket.emit("new-message", msgObj)
        if (selectedFile) {
            const media = {
                to_user_id: receiver_id,
                file: selectedFile,
                from_user_id: user.chat_id,
                socket
            }
            dispatch(uploadMediaToserver(media))
            setIsFilePicked(false)
            setSelectedFile('')
            setQueState(prevState => ({
                ...prevState,
                inQueFilePreview: '',
                inQueFile: ''
            }))
        }
    }

    const changeHandler = (event) => {
        const user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
        const receiver_id = selectedContactDetail.chat_user
        const file = event.target.files[0]
        setFileUploadError(false)
        if (!file) return
        if (allowedFiles().includes(file.name?.split('.').pop().toLowerCase())) {
            setSelectedFile(file)

            getBase64(file, imageUrl => {
                // console.log('inQueFilePreview', imageUrl)
                setQueState(prevState => ({
                    ...prevState,
                    inQueFilePreview: imageUrl,
                    inQueFile: file
                }))
            })
            setIsFilePicked(true)
        } else {
            setSelectedFile(null)
            setQueState({
                inQueFilePreview: '',
                inQueFile: ''
            })
            setFileUploadError(true)
        }
    }

    const appendTemplate = (item) => {
        const content = htmlToDraft(item.template)
        const contentState = ContentState.createFromBlockArray(content?.contentBlocks)
        const createContent = EditorState.createWithContent(contentState)
        if (item?.type === 'message') {
            setMsgEditorState(createContent)
            setMsg(item.template)
        } else {
            setMassMsgEditorState(createContent)
            setBroadcastMessage(item.template)
        }
    }

    const getRdList = (option) => {
        setSelectedBraodcastContacts([])
        setBroadCastRDsList([])
        setCheckAllVal(false)
        setFavFolderList(null)
        setBackToFav(false)
        setSelectedRds([])
        dispatch({type: "CLEAR_FAV_FOLDERS_LIST"})
        dispatch({type: "CLEAR_FAV_PROFILES"})
        setSelectedRadio(option)
        if (option === 'my_rds') {
            setBroadCastRDsListLoading(true)
            setShowFav(false)
            setShowGroups(false)
            dispatch(myRdList())
        } else if (option === 'all_rds') {
            setBroadCastRDsListLoading(true)
            setShowFav(false)
            setShowGroups(false)
            dispatch(allRdList())
        } else if (option === 'groups') {
            setBroadCastRDsListLoading(false)
            setShowFav(false)
            setShowGroups(true)
        } else if (option === 'favourites') {
            setBroadCastRDsListLoading(true)
            setShowFav(true)
            setShowGroups(false)
            const API_URL = process.env.REACT_APP_BASEURL
            dispatch(getFavoriteFolders(true, `${API_URL}brand/load-folder-list?list=all`))
        }
    }

    const handleSelectBroadCastingContact = (contact) => {
        setCheckAllVal(false)
        let list = [...selectedBroadcastContacts]
        let names = [...selectedRds]
        if (!list.includes(contact.user_id)) {
            list.push(contact.user_id)
            names.push(contact.name)
        } else {
            list = list.filter(id => id !== contact.user_id)
            names = names.filter(name => name !== contact.name)
        }
        setSelectedBraodcastContacts(list)
        setSelectedRds(names)
    }

    const sendBroadcastMessage = () => {
        const user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
        const date = new Date()
        const msgObj = {
            message: broadcastMessage,
            from_user_id: user.chat_id,
            role: "rd",
            socket,
            to_users: selectedBroadcastContacts,
            timezone: date.toString()
        }
        setBroadCastSendLoader(true)
        dispatch(sendBroadcastMsg(msgObj))
    }

    const renderChats = () => {
        const messages = selectedUserBrandChat?.data
        if (!messages || messages.length === 0) {
            return (
                <div className="d-flex flex-column align-items-center justify-content-center" style={{height: '100%', minHeight: '200px', color: '#aaa'}}>
                    <MessageSquare size={40} style={{marginBottom: '10px', opacity: 0.4}}/>
                    <p style={{fontSize: '0.9rem'}}>No messages yet. Start the conversation!</p>
                </div>
            )
        }
        return messages.map((item, index) => {
            return (
                <div
                    ref={(el) => (ps.current[index] = el)}
                    key={index}
                    className={classnames("chat", {
                        "chat-left": item?.to_user_id !== selectedContactDetail?.chat_user
                    })}
                >
                    <div className="chat-avatar">
                        <Link
                            to={item?.to_user_id === selectedContactDetail?.chat_user ? `/dashboard/brands/profile` : `/dashboard/brands/nutritions/${item?.from_user_id}`}>
                            <CustomAvatar
                                name={item?.to_user_id === selectedContactDetail?.chat_user ? (currentUser?.name || 'Me') : (selectedContactDetail?.name || selectedContactDetail?.rd_name)}
                                img={item?.to_user_id === selectedContactDetail?.chat_user ? currentUser?.logo : (selectedContactDetail?.profile_image || selectedContactDetail?.profile_img)}
                                className='box-shadow-1 cursor-pointer'
                                imgHeight='44'
                                imgWidth='44'
                            />
                        </Link>
                    </div>
                    {item.media ? (
                        <div className="chat-body">
                            <div className="chat-content media-file">
                                {item.message_type === "img" && (
                                    <div>
                                        <img src={item.media} height="200" title={item.file_name} alt={item.file_name}/>
                                        <p className="mt-2 text-primary font-small-2 text-center cursor-pointer"
                                           style={{textDecoration: "underline"}}>
                                            <a href={item.media} target="_blank">Download</a>
                                        </p>
                                    </div>
                                )}
                                {item.message_type === "pdf" && (
                                    <div>
                                        <File size={100} style={{color: '#56B6FF'}}/>
                                        <p className="mt-2 text-primary font-small-2 text-center cursor-pointer"
                                           style={{textDecoration: "underline"}}>
                                            <a href={item.media} target="_blank">Download</a>
                                        </p>
                                    </div>
                                )}
                                {item.message_type === "doc" && (
                                    <div>
                                        <File size={100} style={{color: '#56B6FF'}}/>
                                        <p className="mt-2 text-primary font-small-2 text-center cursor-pointer"
                                           style={{textDecoration: "underline"}}>
                                            <a href={item.media} target="_blank">Download</a>
                                        </p>
                                    </div>
                                )}
                                {/*<p><a href={item.media} target='_blank'>{item.file_name}</a></p>*/}
                            </div>
                            {item.send_by &&
                                <p className="child"> sent by {item.send_by}</p>
                            }
                        </div>
                    ) : (
                        <>
                            <div className="chat-body">
                                <div className="chat-content text-break" style={{whiteSpace: "break-spaces"}}>
                                    <div dangerouslySetInnerHTML={{__html: item.message}}></div>
                                    <p className="child" style={{marginTop: "10px", textAlign: "right"}}>
                                        {item.timezone}
                                    </p>
                                </div>
                            </div>
                            <div className="child" style={{marginRight: "50px", textAlign: "right"}}>
                                {item.send_by && <p> sent by {item.send_by}</p>}
                            </div>
                        </>
                    )}
                </div>
            )
        })
    }

    const renderMassMessageContent = () => {
        const detail = brandChatStoreSlice?.massMessageDetail
        const selectedUserBrandChatLoading = brandChatStoreSlice?.selectedUserBrandChatLoading
        if (selectedUserBrandChatLoading) {
            return (
                <div className="d-flex align-items-center justify-content-center p-5">
                    <Spinner color="primary" /> <span className="ml-2">Loading broadcast detail...</span>
                </div>
            )
        }
        const messageHtml = detail?.message || selectedContactDetail?.last_message || ''
        const recipients = detail?.recipients || []
        return (
            <div className="p-3" style={{ maxWidth: '850px', margin: '0 auto' }}>
                <Card className="shadow-sm mb-3">
                    <CardBody className="p-3">
                        <div className="d-flex align-items-center justify-content-between mb-2 pb-1 border-bottom">
                            <div className="d-flex align-items-center">
                                <Send size={18} className="text-primary mr-1" />
                                <h5 className="mb-0 font-weight-bold">Broadcast Message Content</h5>
                            </div>
                            <span className="badge badge-light-secondary px-2 py-1">
                                {detail?.created_at || selectedContactDetail?.created_at || 'Sent recently'}
                            </span>
                        </div>
                        <div
                            className="message-html-container p-2 bg-light rounded"
                            dangerouslySetInnerHTML={{ __html: messageHtml }}
                            style={{ fontSize: '0.95rem', lineHeight: '1.6' }}
                        />
                    </CardBody>
                </Card>

                <Card className="shadow-sm mb-3">
                    <CardBody className="p-3">
                        <div className="d-flex align-items-center justify-content-between mb-2 pb-1 border-bottom">
                            <div className="d-flex align-items-center">
                                <Users size={18} className="text-primary mr-1" />
                                <h5 className="mb-0 font-weight-bold">
                                    Recipients ({detail?.total_recipients || recipients.length || 0} RDs)
                                </h5>
                            </div>
                        </div>
                        <Row>
                            {recipients.map((r, i) => (
                                <Col key={i} md={4} sm={6} className="mb-2">
                                    <div className="d-flex align-items-center p-2 rounded border bg-white shadow-xs">
                                        <Link to={`/dashboard/brands/nutritions/${r.user_id}`} title="View RD profile">
                                            <CustomAvatar
                                                name={r.name}
                                                img={r.profile_image}
                                                imgHeight='44'
                                                imgWidth='44'
                                                className="mr-2 cursor-pointer avatar-img-fit-contain"
                                            />
                                        </Link>
                                        <div className="text-truncate">
                                            <Link to={`/dashboard/brands/nutritions/${r.user_id}`} className="text-dark font-weight-bold d-block text-truncate">
                                                {r.name}
                                            </Link>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </CardBody>
                </Card>

                <Alert color="info" className="d-flex align-items-center mb-0">
                    <Info size={18} className="mr-2 flex-shrink-0" />
                    <div style={{ fontSize: '0.85rem' }}>
                        <strong>1:1 Reply Branching Active:</strong> This is a broadcast send. When any dietitian replies, their response automatically creates a direct 1:1 conversation in your Inbox.
                    </div>
                </Alert>
            </div>
        )
    }

    const handleStartConversation = () => {
        if (!userSidebarLeft && window.innerWidth <= 1200) {
            handleSidebar()
        }
    }

    const ChatWrapper = selectedContactDetail && selectedUserBrandChat ? PerfectScrollbar : 'div'

    const handleCheckAll = (e) => {
        const checked = e.target.checked
        const list = [...selectedBroadcastContacts]
        const names = [...selectedRds]
        if (checked) {
            setCheckAllVal(true)
            for (const item of broadCastRDsList) {
                if (!list.includes(item.user_id)) {
                    list.push(item.user_id)
                    names.push(item.name)
                }
            }
            setSelectedBraodcastContacts(list)
            setSelectedRds(names)
        } else {
            setCheckAllVal(false)
            setSelectedBraodcastContacts([])
            setSelectedRds([])
        }
    }

    const handleSelectedFolder = (folderId, folderTitle) => {
        setBackToFav(true)
        setShowFav(false)
        setFavFolderId(folderId)
        setFavFolderTitle(folderTitle)
        setBroadCastRDsListLoading(true)
        setSelectedBraodcastContacts([])
        setBroadCastRDsList([])
        setFavFolderList(null)
        dispatch({type: "CLEAR_FAV_FOLDERS_LIST"})
        const API_URL = process.env.REACT_APP_BASEURL
        dispatch(getFavoriteRDProfiles(true, `${API_URL}brand/favorites-profiles?folder_id=${folderId}&list=all`, ''))
    }

    const handleGroupChange = (category, event, value) => {
        dispatch(rdGroupListReset())
        setBroadCastRDsList([])
        setSelectedBraodcastContacts([])
        setGroupData(prevGroupData => {
            const newGroupData = {...prevGroupData}
            const index = newGroupData[category].indexOf(value?.id)
            if (index === -1) {
                newGroupData[category] = [...newGroupData[category], value?.id]
            } else {
                newGroupData[category] = [
                    ...newGroupData[category].slice(0, index),
                    ...newGroupData[category].slice(index + 1)
                ]
            }
            return newGroupData
        })
    }

    useEffect(() => {
        if (groupData.speciality.length > 0 || groupData.industry.length > 0 || groupData.characteristics.length > 0) {
            dispatch(rdGroupList({
                speciality: groupData.speciality,
                industry: groupData.industry,
                personal_attr: groupData.characteristics,
                filter: 'list'
            }))
        }
    }, [groupData])

    return (
        <Fragment>
            <div className="chat-app-window w-100 chat-brand">
                <div className={classnames("start-chatArea-parent", {
                    "d-none": !!selectedContactDetail
                })}>
                    <div className="chat-navbar">
                        <header className="chat-header">
                            <div className="d-flex align-items-center justify-content-lg-end justify-content-between">
                                <div className='sidebar-profile-toggle'>
                                    <Button.Ripple className='btn-icon'
                                                   color='primary'
                                                   id="send-mass-msg"
                                                   title="Send a mass message"
                                                   size='sm'
                                                   onClick={() => {
                                                       setIsOpenBroadcastModal(true)
                                                       setSelectedBraodcastContacts([])
                                                       setCheckAllVal(false)
                                                       setSelectedRds([])
                                                       getRdList('my_rds')
                                                   }}
                                    >
                                        <MessageCircle size={14}/> Mass Message
                                    </Button.Ripple>
                                </div>
                            </div>

                        </header>
                    </div>
                    <div
                        className={classnames("start-chat-area", {
                            "d-none": !!selectedContactDetail
                        })}>
                        {/* <div className='start-chat-area'> */}
                        <div className="start-chat-icon mb-1">
                            <MessageSquare/>
                        </div>
                        <h4 className="sidebar-toggle start-chat-text text-center">
                            <div>Select a RD First to Start Chat.</div>
                            <button className="d-sm-none btn btn-link font-medium-3 text-underline" onClick={handleStartConversation}>
                                Tap Here
                            </button>
                        </h4>
                    </div>
                </div>
                <div
                    className={classnames("active-chat", {
                        "d-none": selectedContactDetail === null
                    })}
                >
                    <div className="chat-navbar">
                        <header className="chat-header">
                            <div className="d-flex align-items-center">
                                <div className="sidebar-toggle d-block d-lg-none mr-1 ">
                                    <button onClick={handleSidebar} className='btn btn-link p-0'>
                                        <ChevronLeft size={21}/>
                                    </button>
                                </div>
                                {selectedContactDetail && (
                                    selectedContactDetail?.is_mass_group || selectedContactDetail?.user_type === 'mass' ? (
                                        <div className='d-flex align-items-center text-body ml-75'>
                                            <CustomAvatar
                                                name="Mass Message"
                                                img={null}
                                                imgHeight='32'
                                                imgWidth='32'
                                                className='mr-50'
                                            />
                                            <div className='d-flex flex-column justify-content-center'>
                                                <h6 className='mb-0' style={{ lineHeight: '1.2', fontSize: '13px' }}>
                                                    {selectedContactDetail?.name}
                                                </h6>
                                            </div>
                                        </div>
                                    ) : (
                                        <Link
                                            to={`/dashboard/brands/nutritions/${selectedContactDetail?.chat_user}`}
                                            className='d-flex align-items-center text-body ml-75'
                                            title='View RD profile'
                                        >
                                            <CustomAvatar
                                                name={selectedContactDetail?.name || selectedContactDetail?.rd_name}
                                                img={selectedContactDetail?.profile_image || selectedContactDetail?.profile_img}
                                                imgHeight='32'
                                                imgWidth='32'
                                                className='mr-50'
                                            />
                                            <div className='d-flex flex-column justify-content-center'>
                                                <h6 className='mb-0' style={{ lineHeight: '1.2', fontSize: '13px' }}>{selectedContactDetail?.name || selectedContactDetail?.rd_name}</h6>
                                            </div>
                                        </Link>
                                    )
                                )}
                            </div>
                            <div className="w-100 d-flex align-items-center justify-content-end">
                                <div className='sidebar-profile-toggle'>
                                    <Button.Ripple className='btn-icon'
                                                   color='primary'
                                                   id="send-mass-msg"
                                                   title="Send a mass message"
                                                   size='sm'
                                                   onClick={() => {
                                                       setIsOpenBroadcastModal(true)
                                                       setSelectedBraodcastContacts([])
                                                       setCheckAllVal(false)
                                                       setSelectedRds([])
                                                       getRdList('my_rds')
                                                   }}
                                    >
                                        <MessageCircle size={14}/> Mass Message
                                    </Button.Ripple>
                                </div>
                            </div>
                        </header>
                    </div>
                    <ChatWrapper containerRef={ref => {
                        chatArea.current = ref
                    }}
                                 className="user-chats"
                                 options={{wheelPropagation: false}}
                    >
                        <div className="chats">
                            {selectedContactDetail?.is_mass_group || selectedContactDetail?.user_type === 'mass' ? (
                                renderMassMessageContent()
                            ) : (
                                <Fragment>
                                    {brandChatStoreSlice?.selectedUserBrandChatLoading &&
                                        <div className="text-center mt-4"><Spinner color='primary'/></div>}
                                    {!brandChatStoreSlice?.selectedUserBrandChatLoading && <Fragment>{renderChats()}</Fragment>}
                                </Fragment>
                            )}
                        </div>
                    </ChatWrapper>
                    {selectedContactDetail?.is_mass_group || selectedContactDetail?.user_type === 'mass' ? (
                        <div className="chat-app-form d-flex align-items-center justify-content-center p-2 bg-light border-top text-muted" style={{ minHeight: '60px' }}>
                            <Info size={16} className="mr-1 text-info" />
                            <span style={{ fontSize: '0.85rem' }}>Broadcast log view (read-only). Direct replies from RDs appear in your Inbox.</span>
                        </div>
                    ) : (
                    <div className="bg-white d-block chat-bottom-wrapper">
                        {fileUploadError &&
                            <div className="validation-err ml-1">{allowedFilesErrorMessages().IMAGE_AND_FILES} </div>}
                        {showFollowUp && (
                            <div className="d-flex align-items-center justify-content-between px-1 py-75" style={{background: '#fff8e1', borderTop: '1px solid #ffe082'}}>
                                <small className='text-muted'>
                                    No reply in <strong>{daysSince} days</strong>. Send a follow-up?
                                </small>
                                <div className='d-flex' style={{gap: '8px'}}>
                                    <button
                                        className='btn btn-sm btn-outline-primary'
                                        onClick={() => {
                                            const followUpText = `<p>Hi, just following up on my previous message. Let me know if you have any questions!</p>`
                                            import('draft-js').then(({ContentState, EditorState}) => {
                                                import('html-to-draftjs').then((mod) => {
                                                    const htmlToDraft = mod.default
                                                    const {contentBlocks, entityMap} = htmlToDraft(followUpText)
                                                    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap)
                                                    setMassMsgEditorState(EditorState.createWithContent(contentState))
                                                })
                                            })
                                        }}
                                    >
                                        Send Follow-up
                                    </button>
                                    <button
                                        className='btn btn-sm btn-outline-secondary'
                                        onClick={() => {
                                            dispatch(archiveConversation(selectedContactDetail?.chat_user))
                                            if (onTabChange) {
                                                onTabChange('archive')
                                            }
                                        }}
                                    >
                                        Archive Thread
                                    </button>
                                </div>
                            </div>
                        )}
                        <Form className="chat-app-form" onSubmit={(e) => handleSendMsg(e)}>
                            <Row>
                                <Col xs={12} lg={12}>
                                    <Editor
                                        editorState={msgEditorState}
                                        onEditorStateChange={(e) => {
                                            setMsgEditorState(e)
                                            const contentState = e.getCurrentContent()
                                            if (contentState.hasText()) {
                                                setMsg(draftToHtml(convertToRaw(e.getCurrentContent())))
                                            } else {
                                                setMsg('')
                                            }
                                        }}
                                        toolbar={{
                                            options: ['inline', 'blockType', 'fontSize', 'list', 'colorPicker', 'link', 'remove', 'history'],
                                            inline: {
                                                options: ['bold', 'italic', 'underline']
                                            },
                                            list: {
                                                options: ['unordered', 'ordered']
                                            },
                                            blockType: {
                                                options: ['Normal', 'H1', 'H2', 'H3']
                                            },
                                            link: {
                                                popupClassName: 'msg-editor-link-and-img',
                                                showOpenOptionOnHover: false
                                            },
                                            fontSize: {
                                                options: [12, 14, 16, 18, 24, 36]
                                            }
                                        }}
                                        editorClassName='msg-editor'
                                        stripPastedStyles={true}
                                    />
                                </Col>
                                <Col xs={12} lg={12} className="d-flex justify-content-between align-items-center mt-1 pt-75 border-top">
                                    <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                        <Label
                                            className="btn btn-outline-primary btn-icon rounded-circle mb-0 cursor-pointer d-flex align-items-center justify-content-center"
                                            htmlFor="attach-doc"
                                            title="Attach file (PDF, Image, Doc)"
                                            style={{ width: '38px', height: '38px', padding: 0 }}
                                        >
                                            <Paperclip size={18} />
                                            <input type="file"
                                                id="attach-doc"
                                                accept=".pdf, .png, .jpg, .jpeg, .doc, .docx, .xlsx, .xls"
                                                onChange={changeHandler}
                                                hidden={true}
                                                disabled={sendMsgLoader}
                                            />
                                        </Label>

                                        {questate.inQueFilePreview && (
                                            <div className="badge badge-light-primary d-flex align-items-center py-50 px-75 rounded-pill">
                                                {selectedFile?.type === "application/pdf" ? (
                                                    <FileText size="14" className="mr-50 text-primary" />
                                                ) : (
                                                    <Image size="14" className="mr-50 text-primary" />
                                                )}
                                                <span className="text-truncate mr-50 font-weight-bold" style={{ maxWidth: '140px', fontSize: '12px' }}>
                                                    {selectedFile?.name || 'Attached file'}
                                                </span>
                                                <X size={14}
                                                   className="cursor-pointer text-danger ml-25"
                                                   title="Remove attachment"
                                                   onClick={() => {
                                                       setQueState({ inQueFilePreview: '', inQueFile: '' })
                                                       setSelectedFile(null)
                                                   }}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                        <Button
                                            color="outline-primary"
                                            size="sm"
                                            onClick={() => {
                                                setIsOpenTempleteModal(false)
                                                setOpenTemplatesModal(true)
                                                setTemplateType('message')
                                            }}
                                        >
                                            Templates
                                        </Button>
                                        <Button
                                            color="primary"
                                            outline
                                            size="sm"
                                            onClick={() => {
                                                setOpenTemplatesModal(false)
                                                setIsOpenTempleteModal(true)
                                                setTemplateType('message')
                                            }}
                                            disabled={sendMsgLoader || msg.length === 0}
                                        >
                                            Save Template
                                        </Button>
                                        <Button
                                            color="success"
                                            id="send-message"
                                            disabled={sendMsgLoader || msg.length === 0}
                                            size="sm"
                                            className="d-flex align-items-center"
                                        >
                                            {sendMsgLoader ? (
                                                <Spinner style={{ height: '14px', width: '14px' }} />
                                            ) : (
                                                <Fragment>
                                                    <Send size={14} className="mr-50" />
                                                    <span>Send</span>
                                                </Fragment>
                                            )}
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                    )}
                </div>
            </div>

            <Modal isOpen={isOpenBroadcastModal} size='xl'>
                <ModalHeader>Send a mass message</ModalHeader>
                <ModalBody style={{minHeight: '50px'}}>
                    <FormGroup className='mb-2'>
                        <div className="d-flex justify-content-between flex-wrap">
                            <Label htmlFor='coupon-code'>Write a Message</Label>
                        </div>
                        <Editor editorState={massMsgEditorState} onEditorStateChange={(e) => {
                            setMassMsgEditorState(e)
                            const contentState = e.getCurrentContent()
                            if (contentState.hasText()) {
                                setBroadcastMessage(draftToHtml(convertToRaw(e.getCurrentContent())))
                            } else {
                                setBroadcastMessage('')
                            }
                        }}
                                toolbar={{
                                    options: ['inline', 'blockType', 'fontSize', 'list', 'colorPicker', 'link', 'image', 'remove', 'history'],
                                    inline: {
                                        options: ['bold', 'italic', 'underline']
                                    },
                                    list: {
                                        options: ['unordered', 'ordered']
                                    },
                                    blockType: {
                                        options: ['Normal', 'H1', 'H2', 'H3']
                                    },
                                    link: {
                                        popupClassName: 'msg-editor-link-and-img',
                                        showOpenOptionOnHover: false
                                    },
                                    image: {
                                        popupClassName: 'msg-editor-link-and-img',
                                        defaultSize: {
                                            height: '500',
                                            width: '500'
                                        }
                                    },
                                    fontSize: {
                                        options: [12, 14, 16, 18, 24, 36]
                                    }
                                }}
                                editorClassName='msg-editor'
                                stripPastedStyles={true}
                        />
                    </FormGroup>
                    <FormGroup className='mb-2'>
                        <div className='text-right border-bottom pb-1'>
                            <button className='btn btn-primary mr-1 btn-sm'
                                    onClick={() => {
                                        setOpenTemplatesModal(false)
                                        setIsOpenTempleteModal(true)
                                        setTemplateType('mass')
                                    }} disabled={broadcastMessage.length === 0}
                            >
                                Save Templates
                            </button>
                            <button className='btn btn-success btn-sm'
                                    onClick={() => {
                                        setIsOpenTempleteModal(false)
                                        setOpenTemplatesModal(true)
                                        setTemplateType('mass')
                                    }}
                            >
                                View Templates
                            </button>
                        </div>
                    </FormGroup>
                    <FormGroup className='border-bottom pb-1'>
                        <Row>
                            <Col xs={12} lg={2}>
                                {broadCastRDsList.length > 0 && showGroups === false && (
                                    <CustomInput
                                        key="3"
                                        type='checkbox'
                                        id="check-all"
                                        label="Select All"
                                        name="check_all"
                                        onChange={handleCheckAll}
                                        checked={checkAllVal}
                                    />
                                )}
                            </Col>
                            <Col xs={12} lg={2}>
                                <CustomInput
                                    key="1"
                                    type='radio'
                                    id="my-rds"
                                    label="My RDs"
                                    onChange={() => getRdList('my_rds')}
                                    className="mr-2"
                                    name="selectRDs"
                                    checked={selectedRadio === 'my_rds'}
                                    disabled={broadCastRDsListLoading}
                                />
                            </Col>
                            <Col xs={12} lg={2}>
                                <CustomInput
                                    key="2"
                                    type='radio'
                                    id="all-rds"
                                    label="All RDs"
                                    onChange={() => getRdList('all_rds')}
                                    className="mr-2"
                                    name="selectRDs"
                                    checked={selectedRadio === 'all_rds'}
                                    disabled={broadCastRDsListLoading}
                                />
                            </Col>
                            <Col xs={12} lg={2}>
                                <CustomInput
                                    key="3"
                                    type='radio'
                                    id="from-favourites"
                                    label="From Favorites"
                                    onChange={() => getRdList('favourites')}
                                    name="selectRDs"
                                    checked={selectedRadio === 'favourites'}
                                    disabled={broadCastRDsListLoading}
                                />
                            </Col>
                            <Col xs={12} lg={2}>
                                <CustomInput
                                    key="3"
                                    type='radio'
                                    id="groups"
                                    label="Filter"
                                    onChange={() => getRdList('groups')}
                                    name="selectRDs"
                                    checked={selectedRadio === 'groups'}
                                    disabled={broadCastRDsListLoading}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    {showFav && (
                        <div className="p-1 bg-light">
                            <span>
                                <strong>Select Folder</strong>
                            </span>
                        </div>
                    )}
                    {backToFav && (
                        <div className="p-1 bg-light d-flex justify-content-between">
                            <button className="text-primary d-flex align-items-center cursor-pointer ml-1 btn p-0" onClick={() => getRdList('favourites')}>
                                {!broadCastRDsListLoading && (
                                    <>
                                        <ArrowLeftCircle size={15}/> <strong style={{marginLeft: '3px'}}>Back</strong>
                                    </>
                                )}
                            </button>
                            <span><strong>{favFolderTitle}</strong></span>
                        </div>
                    )}
                    <div className="rds-list-message-modal">
                        <Row>
                            {showGroups && (
                                <>
                                    <Col xs={12} md={4}>
                                        <FormGroup>
                                            <h6 className='filter-title bg-light p-1 font-weight-bold'>Speciality:</h6>
                                            <div style={{height: '250px', overflow: 'auto'}}>
                                                {brandsDashboardStoreSlice?.goalsAttributes?.speciality?.map((brand, index) => (
                                                    <CustomInput key={index}
                                                                 type='checkbox'
                                                                 className="mx-2 mb-1"
                                                                 name={`speciality-${index}`}
                                                                 id={`speciality-${index}`}
                                                                 label={brand.label}
                                                                 onChange={(e) => handleGroupChange('speciality', e, brand)}
                                                                 disabled={rdGroupListLoading}
                                                    />
                                                ))}
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} md={4}>
                                        <FormGroup>
                                            <h6 className='filter-title bg-light p-1 font-weight-bold'>Industry:</h6>
                                            <div style={{height: '250px', overflow: 'auto'}}>
                                                {brandsDashboardStoreSlice?.goalsAttributes?.industry?.map((brand, index) => (
                                                    <CustomInput key={index}
                                                                 type='checkbox'
                                                                 className="mx-2 mb-1"
                                                                 name={`industry-${index}`}
                                                                 id={`industry-${index}`}
                                                                 label={brand.label}
                                                                 onChange={(e) => handleGroupChange('industry', e, brand)}
                                                                 disabled={rdGroupListLoading}
                                                    />
                                                ))}
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} md={4}>
                                        <FormGroup>
                                            <h6 className='filter-title bg-light p-1 font-weight-bold'>Personal Characteristics:</h6>
                                            <div style={{height: '250px', overflow: 'auto'}}>
                                                {brandsDashboardStoreSlice?.goalsAttributes?.personal_attributes?.map((brand, index) => (
                                                    <CustomInput key={index}
                                                                 type='checkbox'
                                                                 className="mx-2 mb-1"
                                                                 name={`personal-characteristics-${index}`}
                                                                 id={`personal-characteristics-${index}`}
                                                                 label={brand.label}
                                                                 onChange={(e) => handleGroupChange('characteristics', e, brand)}
                                                                 disabled={rdGroupListLoading}
                                                    />
                                                ))}
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    {broadCastRDsList.length > 0 && (
                                        <Col md={12}>
                                            <div className='bg-light p-1 mt-2 mb-2'>
                                                <strong>Total RD's Found: {broadCastRDsList.length}</strong>
                                            </div>
                                        </Col>
                                    )}
                                </>
                            )}
                            {(broadCastRDsListLoading || rdGroupListLoading) &&
                                <Col md={12} className="text-center">
                                    <Spinner color="primary" style={{width: '16px', height: '16px'}}/> Please wait...
                                </Col>
                            }
                            {!broadCastRDsListLoading && broadCastRDsList?.map((item, index) => (
                                <Col className="col-md-3" key={index}>
                                    <Card className={classnames({
                                        'ecommerce-card': true,
                                        'mb-1': true,
                                        'border-1px-white': (!selectedBroadcastContacts?.includes(item.user_id)),
                                        'cursor-pointer': true,
                                        'border-1px-purple': selectedBroadcastContacts?.includes(item.user_id)
                                    })} key={item.user_id} onClick={() => handleSelectBroadCastingContact(item)}>
                                        <CardBody className="d-flex align-items-center justify-content-between">
                                            <div className="d-flex align-items-center">
                                                <CustomInput id={`user-checkbox-${index}`}
                                                             type='checkbox'
                                                             checked={selectedBroadcastContacts?.includes(item.user_id)}
                                                             className="mr-1"
                                                             disabled={true}
                                                />
                                                <CustomAvatar
                                                    name={item?.name || item?.rd_name}
                                                    img={item?.profile_img || item?.profile_image}
                                                    imgHeight='36'
                                                    imgWidth='36'
                                                />
                                                <div>
                                                    <h5 className='mb-0 ml-1 text-break'> {item.name}</h5>
                                                    {item.is_favorite &&
                                                        <p className='mb-0 ml-1 folder-name-at-broadcast-rds'>
                                                            {item?.folder_title?.length > 10 ? ` ${item?.folder_title.substring(0, 10)}...` : item?.folder_title}
                                                        </p>}
                                                </div>
                                            </div>
                                            {item.is_favorite && <Heart color="red" size={16}/>}
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))}
                            {favFolderList && favFolderList.map((item, index) => (
                                <Col xs={12} md={3}>
                                    <Card key={index} className="cursor-pointer" onClick={() => handleSelectedFolder(item.id, item.folder_name)}>
                                        <CardBody className=" fav-folders">
                                            <div className="align-items-center">
                                                <h5 className='mb-0'>
                                                    {item?.folder_name.length > 20 ? `${item?.folder_name.substring(0, 20)}...` : item?.folder_name}
                                                </h5>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                        {broadCastRDsListLoading === false && broadCastRDsList.length === 0 && showFav === false && showGroups === false && (
                            <div className="text-center">
                                <strong>Sorry! No data found.</strong>
                            </div>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color='danger' outline onClick={() => {
                        setIsOpenBroadcastModal(!isOpenBroadcastModal)
                        setSelectedBraodcastContacts([])
                        setCheckAllVal(false)
                        setBroadCastRDsList([])
                        setMassMsgEditorState(null)
                        setBroadcastMessage('')
                        dispatch({type: 'CLEAT_BROADCAST_LIST'})
                    }}>
                        Cancel
                    </Button>
                    <Button color='primary' disabled={selectedBroadcastContacts.length === 0 || broadcastMessage === ''}
                            onClick={() => {
                                setShowPreviewModal(true)
                            }}>
                        Send
                    </Button>
                </ModalFooter>
            </Modal>

            {/* Mass messages preview modal*/}
            <Modal isOpen={showPreviewModal} className='modal-lg'>
                <ModalHeader>Confirmation</ModalHeader>
                <ModalBody style={{minHeight: '50px'}}>
                    <Alert color="success" isOpen={broadCastResStatus}>
                        <div className='alert-body'>
                            {broadCastResMsg}
                        </div>
                    </Alert>

                    <FormGroup className='mb-2'>
                        <Label htmlFor='coupon-code'><strong>Message</strong></Label>
                        <div dangerouslySetInnerHTML={{__html: broadcastMessage}} style={{minHeight: '150px'}}
                             className="bg-light p-1 border text-break"></div>
                    </FormGroup>
                    <FormGroup className='mb-2'>
                        <Label htmlFor='coupon-code'><strong>To ({selectedRds.length})</strong></Label>
                        <div className="rds-list-message-modal">
                            {selectedRds.map((name) => (
                                <span className="badge badge-primary mb-1 mr-1">{name}</span>
                            ))}
                        </div>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color='danger' outline onClick={() => setShowPreviewModal(false)}
                            disabled={broadCastSendLoader}>
                        Cancel
                    </Button>
                    <Button color='primary' onClick={() => sendBroadcastMessage()}
                            disabled={broadCastSendLoader || broadCastResStatus}>
                        {broadCastSendLoader ? <Spinner style={{height: '14px', width: '14px'}}/> : "Send"}
                    </Button>
                </ModalFooter>
            </Modal>

            {/* --- Template Modal --- */}
            <MsgTemplates showSaveModal={isOpenTempleteModal}
                          template={templateType === 'message' ? msg : broadcastMessage}
                          closeModal={() => {
                              setIsOpenTempleteModal(false)
                              setOpenTemplatesModal(false)
                              setTemplateType(null)
                          }}
                          templateType={templateType}
                          showTemplatesModal={openTemplatesModal}
                          applyTemplate={(data) => {
                              appendTemplate(data)
                          }}
            />
        </Fragment>
    )
}

ChatLog.propTypes = {
    handleUser: PropTypes.func.isRequired,
    handleUserSidebarRight: PropTypes.func.isRequired,
    handleSidebar: PropTypes.func.isRequired,
    store: PropTypes.object,
    userSidebarLeft: PropTypes.bool.isRequired,
    user: PropTypes.object,
    selectedUserID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selectedUserBrandChat: PropTypes.object,
    selectedContactDetail: PropTypes.object,
    currentUser: PropTypes.object
}

export default memo(ChatLog)